import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import Link from 'components/visualization/MediaModal/Link'
import StreamSymbol from 'enums/StreamSymbol'
import { setAutoId, AutomationId } from 'utils/automationUtil'

const Container = styled.div.attrs(() => setAutoId(AutomationId.photoConcept.retweetedAuthor))<{
  mode: Theme
}>`
  text-wrap: no-wrap;
  color: ${({ mode }) => sys[mode].text.placeholder};
`

const StyledLink = styled(Link)<{ mode: Theme }>`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
`

interface RetweetedAuthorProps {
  dataStream?: string
  name?: string
  url?: string
}

const RetweetedAuthor = ({ dataStream = '', name, url }: RetweetedAuthorProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()
  const isForwarded = [
    StreamSymbol.BRDTW,
    StreamSymbol.BRDWS,
    StreamSymbol.BRDWC,
    StreamSymbol.WEIBO
  ].includes(dataStream)

  return (
    <Container mode={theme}>
      {isForwarded ? t('forwardedBy') : t('retweetedBy')}&nbsp;
      <StyledLink mode={theme} href={url}>
        {name}
      </StyledLink>
    </Container>
  )
}

export default RetweetedAuthor
